import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { places } from './Destinations';

export default function DestinationsMarquee() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [trackWidth, setTrackWidth] = useState(1200); // fallback width
  const SPEED_PX_PER_SEC = 120;

  useEffect(() => {
    const measure = () => {
      if (trackRef.current) {
        // Measure width of single sequence (half of duplicated list)
        const children = trackRef.current.children.length;
        if (children > 0) {
          // Since content is duplicated, half the scroll distance is the width of half the children
          const half = Math.floor(children / 2);
          let w = 0;
          for (let i = 0; i < half; i++) {
            const el = trackRef.current.children[i] as HTMLElement;
            w += el.offsetWidth + parseFloat(getComputedStyle(trackRef.current).gap || '0');
          }
          setTrackWidth(Math.max(800, Math.floor(w)));
        }
      }
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (trackRef.current) ro.observe(trackRef.current);
    const onResize = () => measure();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      ro.disconnect();
    };
  }, []);

  // Triple the content to ensure seamless infinite scrolling
  const tripled = [...places, ...places, ...places];

  return (
    <div className="relative bg-gradient-to-r from-[#395958] to-[#2a4342] text-white py-4 overflow-hidden">
      <motion.div
        ref={trackRef}
        initial={{ x: 0 }}
        animate={{ x: -trackWidth }}
        transition={{
          ease: 'linear',
          duration: trackWidth / SPEED_PX_PER_SEC,
          repeat: Infinity,
          repeatType: 'loop'
        }}
        className="flex whitespace-nowrap gap-12"
        aria-label="Destinations marquee"
      >
        {tripled.map((place, idx) => (
          <div key={`${place.title}-${idx}`} className="relative group inline-flex items-center">
            <span
              className="font-light uppercase text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl leading-none tracking-tight transition-transform duration-300 group-hover:scale-105"
              style={{ color: '#F1D291' }}
            >
              {place.title}
            </span>
            <span aria-hidden className="mx-3 sm:mx-4 text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl" style={{ color: '#F1D291' }}>•</span>
            <div className="pointer-events-none absolute left-1/2 -translate-x-1/2 -top-44 w-64 h-40 rounded-md overflow-hidden shadow-xl opacity-0 group-hover:opacity-100 transition-all duration-300 z-20">
              <img src={place.image} alt={place.title} className="w-full h-full object-cover" />
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  );
}